const defaultOptions: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
};

export function convertDateToUserTimeZone(
  inputDate: string | Date | number,
  options: Intl.DateTimeFormatOptions = defaultOptions,
  formattingOptions: 'format' | 'formatToParts' = 'format',
) {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const date = new Date(inputDate);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date input');
  }

  const formatOptions = { timeZone: userTimeZone, ...options };

  const formatter = new Intl.DateTimeFormat('en-US', formatOptions);
  const userTimeZoneDate = formatter[formattingOptions](date);

  return userTimeZoneDate;
}
